import React, { useEffect } from 'react'
import { Box, Typography } from '@mui/material'
import CaptchaModal from 'src/components/CaptchaModal'
import {
  closeCaptchaModal,
  setCaptchaToken,
} from 'src/features/home/ducks/home.reducer'
import { useAppDispatch, useAppSelect } from 'src/hooks/useRedux'

import { FraudulentForm } from './components'

const Report: React.FC = () => {
  const { captchaModalOpen } = useAppSelect((state) => state.home)
  const dispatch = useAppDispatch()

  // scroll to top
  useEffect(() => {
    window.scrollTo({ behavior: 'smooth', top: 0 })
  }, [])

  return (
    <Box component="div" sx={{ position: 'relative', width: '100%' }}>
      <Box
        component="div"
        sx={{
          width: '70%',
          margin: (theme) => theme.spacing(50, 'auto'),
          '@media (max-width: 1000px)': {
            width: '60%',
            margin: (theme) => theme.spacing(30, 'auto'),
          },
          '@media (max-width: 600px)': {
            width: '90%',
            margin: (theme) => theme.spacing(20, 'auto'),
          },
        }}
      >
        <Typography
          textAlign="center"
          fontSize={(theme) => theme.typography.fontSize * 4}
          fontWeight="bold"
          mb={30}
          sx={{
            '@media (max-width: 1000px)': {
              fontSize: (theme) => theme.typography.fontSize * 2.67,
              mb: 20,
            },
            '@media (max-width: 600px)': {
              fontSize: (theme) => theme.typography.fontSize * 2,
              mb: 15,
            },
          }}
        >
          Report Fraudulent Card
        </Typography>

        {/* {state && <UserCardComponent card={state.card} scheme={scheme} />} */}
        <FraudulentForm />
      </Box>

      <CaptchaModal
        open={captchaModalOpen}
        onToken={(token) => {
          dispatch(setCaptchaToken(token))
          dispatch(closeCaptchaModal())
        }}
        onClose={() => {
          dispatch(closeCaptchaModal())
        }}
      />
    </Box>
  )
}

export default Report
